module.exports = __webpack_public_path__ + "static/media/HollywoodMovies1Thumb.17de7691.jpg";